
import Accordion from './Accordion';
import BusRatesTable from './BusRatesTable';
import CustomCarousel from './CustomCarousel';
import Gallery from './Smallimages';
import './smallkey.css';
import { Helmet } from 'react-helmet';

function Bestpicnicspotnearamravati() {



  const cardData =
  {
    keyword: ' Best Picnic Spot Near Amravati',
    heading:  'Woodland Escape: Best Picnic Spot Near Amravati',
    headingDescription: 'Woodland Escape Resort, one of the best picnic spots near Amravati, offers a refreshing retreat surrounded by lush greenery, forested trails, and serene natural beauty — perfect for a relaxing day with family and friends. Just a short drive from Amravati, the resort combines peaceful ambiance with fun-filled activities, including nature walks, outdoor games, swimming, and adventure experiences for all age groups. Guests can unwind on scenic lawns, enjoy delicious meals, and soak in the calm countryside charm that makes every moment rejuvenating. Whether it’s a casual day picnic, a friends’ getaway, or a family outing, Woodland Escape Resort near Amravati provides the ideal mix of relaxation, recreation, and nature’s bliss for a memorable escape from the city.',

    top: 'Top Activities of Woodland Escape Resort Near Nagpur',
   "topPlaces": [
  {
    "title": "Forest Retreat Stay Experience",
    "description": "Woodland Escape Resort offers a serene getaway surrounded by dense forests, misty hills, and soothing sounds of nature. Guests wake up to the melodies of chirping birds and the cool fragrance of dewy mornings. The resort blends rustic charm with modern elegance, creating an ambiance of true peace and comfort. Every corner reflects nature’s simplicity, encouraging travelers to disconnect from the city rush. Whether you’re lounging on the porch with a cup of tea or strolling through the green pathways, the stay promises calmness and clarity. It’s a retreat where you can breathe freely, unwind deeply, and reconnect with your natural rhythm."
  },
  {
    "title": "Luxury Cottages Amid Nature",
    "description": "The resort’s cottages are thoughtfully crafted to provide an authentic forest-luxury experience. Each cottage is built using eco-friendly materials and designed to offer panoramic views of the surrounding woods. Inside, guests enjoy spacious interiors, cozy bedding, and all modern amenities while staying close to nature’s essence. The gentle hum of the forest replaces city noise, offering a deeply restful environment. From sunrise reflections on your balcony to starry skies at night, every moment here feels timeless. Families, couples, and solo travelers alike find these cottages perfect for soulful relaxation amidst nature’s raw beauty."
  },
  {
    "title": "Wildlife and Tiger Safari",
    "description": "Adventure seekers can experience the thrill of the wild through guided tiger safaris organized near the resort. The region’s dense forests are home to majestic tigers, deer, peacocks, and countless species of birds. Expert naturalists accompany visitors, ensuring a safe and educational journey through the jungle. Each safari offers an adrenaline rush mixed with awe as you witness the raw beauty of wildlife in its natural habitat. The early morning and evening safaris are especially magical, when golden sunlight filters through the trees and animals emerge from their hiding places. It’s an unforgettable adventure that connects you to the untamed heart of nature."
  },
  {
    "title": "Nature Trails and Jungle Walks",
    "description": "For those who prefer calm exploration, Woodland Escape Resort’s nature trails offer the perfect adventure. Meandering paths take guests through wildflowers, bamboo groves, and hidden forest streams. Every step reveals something new — a bird call, a butterfly dance, or the gentle rustle of leaves. Guided jungle walks help you learn about the region’s biodiversity and plant life. It’s not just a walk; it’s an immersion into a living ecosystem that refreshes the mind and body. The experience is ideal for photographers, nature lovers, and families who want to reconnect with the wonders of the natural world."
  },
  {
    "title": "Campfire and Barbecue Nights",
    "description": "As dusk settles over the forest, Woodland Escape Resort transforms into a magical open-air lounge. Guests gather around the crackling bonfire, sharing laughter and stories under a canopy of stars. The aroma of freshly grilled barbecue fills the air, accompanied by light music and soft forest winds. Whether you’re roasting marshmallows with family or joining a live music night, the warmth of the fire unites everyone in celebration. This nightly ritual captures the essence of togetherness — blending fun, relaxation, and nature’s comfort into one unforgettable evening experience."
  },
  {
    "title": "Adventure and Outdoor Games",
    "description": "Beyond peaceful moments, the resort also offers a range of exciting outdoor adventures. Guests can try their hands at archery, cycling through forest trails, or rope-climbing challenges. A well-equipped outdoor arena allows for group sports like volleyball, cricket, and badminton. For thrill-seekers, there are guided treks and obstacle courses designed for team-building. Each activity encourages bonding, laughter, and energy in the fresh, open air. Whether you’re a corporate group or a family on vacation, the balance of fun and fitness ensures every guest finds their own rhythm of adventure."
  },
  {
    "title": "Farm-to-Table Dining Experience",
    "description": "Dining at Woodland Escape Resort is a celebration of freshness and local flavor. The restaurant follows a true farm-to-table concept, using ingredients sourced from nearby farms and organic gardens. Traditional Maharashtrian and regional delicacies are prepared with authentic recipes and served in an inviting outdoor dining area. Every meal tells a story — of farmers, tradition, and sustainability. The aroma of home-cooked food mingles with the crisp forest air, creating a soulful dining experience. Guests can even participate in small cooking sessions or farm tours to see where their food comes from."
  },
  {
    "title": "Peaceful Meditation and Yoga Zone",
    "description": "For those seeking inner peace, the resort’s meditation and yoga zone offers the perfect sanctuary. Set amidst greenery and birdsong, this space allows guests to practice mindfulness in complete harmony with nature. Morning yoga sessions at sunrise and guided evening meditations under the open sky restore balance and positivity. The calm surroundings, fresh oxygen, and gentle breezes make every breath rejuvenating. Many guests describe it as a spiritual escape where body, mind, and soul realign. Whether you’re an experienced yogi or a beginner, this serene corner helps you rediscover your inner calm."
  }
],



"services": [
{
"name": "Best Picnic Spot Near Amravati",
"description": "Experience a perfect day out at the best picnic spots near Amravati. Enjoy lush greenery, fresh air, and family-friendly environments ideal for relaxation, photography, and leisure activities."
},
{
"name": "Amravati Top Picnic Places",
"description": "Discover the top picnic places in Amravati with scenic surroundings, well-maintained parks, riverside areas, and hills. Perfect for family outings, friends meet-ups, or a solo nature retreat."
},
{
"name": "Amravati Family Picnic Spot",
"description": "Plan a memorable family picnic in Amravati with safe play areas for kids, spacious lawns, picnic benches, and fun outdoor activities suitable for all age groups."
},
{
"name": "Amravati Nature Picnic Spot",
"description": "Connect with nature at Amravati's serene picnic spots surrounded by greenery, rivers, and hills. Ideal for photography, bird watching, and enjoying quiet moments away from the city bustle."
},
{
"name": "Affordable Picnic Spot Amravati",
"description": "Enjoy a budget-friendly picnic experience in Amravati without compromising on comfort and natural beauty. Perfect for students, small families, and group outings."
},
{
"name": "Amravati Weekend Picnic",
"description": "Plan a refreshing weekend getaway to Amravati’s best picnic spots. Relax, play, and rejuvenate with easy access from the city for a stress-free outing."
},
{
"name": "Amravati Riverside Picnic Spot",
"description": "Spend the day by scenic riversides in Amravati, perfect for picnics, boating, photography, and enjoying cool breezes while having a meal with friends and family."
},
{
"name": "Amravati Garden Picnic Spot",
"description": "Visit beautifully landscaped gardens in Amravati for a peaceful picnic experience with flowers, walking paths, shaded areas, and recreational facilities for kids."
},
{
"name": "Amravati Hill Picnic Spot",
"description": "Enjoy a hilltop picnic experience in Amravati with panoramic views, trekking opportunities, and a refreshing escape from the city heat."
},
{
"name": "Amravati Kids Friendly Picnic Spot",
"description": "Perfect for families with children, these picnic spots in Amravati offer safe play areas, fun activities, and interactive experiences designed especially for kids."
},
{
"name": "Amravati Scenic Picnic Spot",
"description": "Capture the beauty of Amravati’s scenic picnic spots, ideal for photography enthusiasts, nature lovers, and anyone looking for tranquil surroundings."
},
{
"name": "Amravati Outdoor Picnic Spot",
"description": "Enjoy a full day of outdoor activities, games, and relaxation in Amravati’s open-air picnic locations surrounded by greenery, rivers, or hills."
},
{
"name": "Amravati Picnic Spot Booking",
"description": "Book your preferred picnic spot in Amravati in advance to ensure a hassle-free experience with all amenities ready for your day out."
},
{
"name": "Amravati Picnic Tour Packages",
"description": "Explore curated picnic tour packages in Amravati that include transportation, meals, guided nature walks, and fun activities for a complete day-trip experience."
},
{
"name": "Amravati Top Weekend Picnic Spot",
"description": "Plan your weekend escape to Amravati’s top picnic locations offering scenic beauty, recreational activities, and relaxation to recharge before the week ahead."
}
],
"tableData": [
["- Best Picnic Spot Near Amravati", "- Amravati Top Picnic Places"],
["- Amravati Family Picnic Spot", "- Amravati Nature Picnic Spot"],
["- Affordable Picnic Spot Amravati", "- Amravati Weekend Picnic"],
["- Amravati Riverside Picnic Spot", "- Amravati Garden Picnic Spot"],
["- Amravati Hill Picnic Spot", "- Amravati Kids Friendly Picnic Spot"],
["- Amravati Scenic Picnic Spot", "- Amravati Outdoor Picnic Spot"],
["- Amravati Picnic Spot Booking", "- Amravati Picnic Tour Packages"],
["- Amravati Top Weekend Picnic Spot", ""]
],
  


whychoose: [
  {
    "WhyChooseheading": "Top Picnic Spot Near Amravati",
    "WhyChoosedescription": "Woodland Escape Resort is the perfect destination for a relaxing family picnic near Amravati, surrounded by lush forest and scenic views. The natural setting offers a peaceful environment where you can unwind and enjoy quality time with loved ones."
  },
  {
    "WhyChooseheading": "Spacious and Comfortable Picnic Areas",
    "WhyChoosedescription": "The resort provides well-maintained picnic zones, shaded seating, and open spaces for families and friends to relax comfortably. Whether you're planning a casual outing or a full-day picnic, the area is designed for convenience and enjoyment."
  },
  {
    "WhyChooseheading": "Activities for All Ages",
    "WhyChoosedescription": "From nature walks and forest trails to pond-side relaxation and light adventure activities, Woodland Escape Resort has options for everyone. Kids can play safely while adults enjoy peaceful surroundings or scenic photography spots."
  },
  {
    "WhyChooseheading": "Safe and Family-Friendly Environment",
    "WhyChoosedescription": "With secure forest paths and supervised areas, parents can relax knowing their children are safe. The resort encourages fun, exploration, and bonding in a protected, natural environment."
  },
  {
    "WhyChooseheading": "Delicious Meals and Refreshments",
    "WhyChoosedescription": "Enjoy freshly prepared meals, snacks, and beverages sourced from local ingredients. The resort provides picnic-friendly options that complement your day outdoors, keeping everyone satisfied and energized."
  },
  {
    "WhyChooseheading": "Perfect for Family and Group Outings",
    "WhyChoosedescription": "Whether you’re visiting with family, friends, or colleagues, Woodland Escape Resort offers ample space and activities to accommodate groups of all sizes. Make memories together while enjoying the serene forest setting."
  },
  {
    "WhyChooseheading": "Easy Accessibility from Amravati",
    "WhyChoosedescription": "Located just a short drive from Amravati, Woodland Escape Resort is easily reachable for a day trip. Its convenient location lets you spend more time enjoying nature and less time traveling, making it an ideal picnic destination."
  }
]












  
  



  }

const faqData = [
  {
    question: "Why choose Woodland Escape Resort as the best picnic spot near Amravati?",
    answer: "Woodland Escape Resort offers a serene and green environment, perfect for a relaxing picnic near Amravati. Families and friends can enjoy nature, open lawns, and a variety of outdoor activities all in one place."
  },
  {
    question: "How far is Woodland Escape Resort from Amravati city?",
    answer: "The resort is located approximately 35–40 km from Amravati, which takes about 1 to 1.5 hours by car. It’s convenient for a day trip or a short picnic outing."
  },
  {
    question: "What activities can we enjoy at Woodland Escape Resort?",
    answer: "Guests can enjoy nature walks, outdoor games, cycling, boating (if available), and picnic-style relaxation. The resort also has dedicated play areas for children and peaceful spots for adults to unwind."
  },
  {
    question: "Is Woodland Escape Resort suitable for family picnics?",
    answer: "Absolutely! The resort is family-friendly with safe outdoor spaces, shaded seating areas, and plenty of recreational activities for all age groups, ensuring everyone has a fun and memorable time."
  },
  {
    question: "Does the resort provide food and picnic arrangements?",
    answer: "Yes! Woodland Escape Resort offers freshly prepared meals, snacks, and beverages. You can choose picnic packages that include lunch, refreshments, and access to outdoor activity zones."
  },
  {
    question: "How can we book a picnic at Woodland Escape Resort near Amravati?",
    answer: "You can book by calling or WhatsApp messaging our reservations team or visiting our official website to reserve your picnic date. Advance booking is recommended, especially on weekends and holidays."
  }
];

const testimonials = [
  {
    name: "Mr. Sameer & Family, Amravati",
    text: "We had a fantastic picnic at Woodland Escape Resort! The surroundings were beautiful, the kids loved the play areas, and the food was delicious. Truly the best picnic spot near Amravati."
  },
  {
    name: "Miss. Priya & Friends, Amravati",
    text: "Woodland Escape Resort made our day out unforgettable! The resort is peaceful, scenic, and full of fun activities. Highly recommended for anyone looking for a picnic near Amravati."
  }
];











      






  const carouselItems = testimonials.map(testimonial => (
    <div key={testimonial.name}>
      <blockquote>

        <p className='testi'>   <span className="quote">“</span>{testimonial.text}</p>
        <footer className=' user'>— {testimonial.name}</footer>
      </blockquote>
    </div>
  ));

  const carouselOptions = {
    loop: true,
    margin: 10,
    nav: true,
    items: 1
  };

  const contactData = {
    heading: `${cardData.keyword} Contact Number`,
    contactNumbers: [
      "+91 9175577266",

    ],
    email: "woodlandescape01@gmail.com"
  };


  const Images = [
  { place: "/images/keyword/1.jpg", text: "1 day tour near Nagpur", link: "1-day-tour-near-Nagpur" },
  { place: "/images/keyword/2.jpg", text: "Best picnic spot near Nagpur", link: "best-picnic-spot-near-Nagpur" },
  { place: "/images/keyword/3.jpg", text: "Family picnic spot near Nagpur", link: "family-picnic-spot-near-Nagpur" },
  { place: "/images/keyword/4.jpg", text: "Nearest picnic spot in Nagpur", link: "nearest-picnic-spot-in-Nagpur" },
  { place: "/images/keyword/5.jpg", text: "Destination wedding spots near Nagpur", link: "destination-wedding-spots-near-Nagpur" },
  { place: "/images/keyword/6.jpg", text: "Pre wedding destination near Nagpur", link: "pre-wedding-destination-near-Nagpur" },
  { place: "/images/keyword/7.jpg", text: "One day adventure resorts near Nagpur", link: "one-day-adventure-resorts-near-Nagpur" },
  { place: "/images/keyword/8.jpg", text: "Activities resort near Nagpur", link: "activities-resort-near-Nagpur" },
  { place: "/images/keyword/9.jpg", text: "Best picnic spot near Akola", link: "best-picnic-spot-near-Akola" },
  { place: "/images/keyword/10.jpg", text: "One day tour near Akola", link: "one-day-tour-near-Akola" },
  { place: "/images/keyword/11.jpg", text: "Resorts near Akola for family", link: "resorts-near-Akola-for-family" },
  { place: "/images/keyword/12.jpg", text: "Destination wedding resorts near Akola", link: "destination-wedding-resorts-near-Akola" },
  { place: "/images/keyword/13.jpg", text: "Best picnic spot near Amravati", link: "best-picnic-spot-near-Amravati" },
  { place: "/images/keyword/14.jpg", text: "One day tour near Amravati", link: "one-day-tour-near-Amravati" },
  { place: "/images/keyword/15.jpg", text: "Family resorts near Amravati", link: "family-resorts-near-Amravati" },
  { place: "/images/keyword/16.jpg", text: "Pre-wedding location near Amravati", link: "pre-wedding-location-near-Amravati" },
  { place: "/images/keyword/17.jpg", text: "Picnic spot near Bhandara", link: "picnic-spot-near-Bhandara" },
  { place: "/images/keyword/18.jpg", text: "One day trip near Bhandara", link: "one-day-trip-near-Bhandara" },
//   { place: "/images/keyword/19.jpg", text: "Resorts near Bhandara for family outing", link: "resorts-near-Bhandara-for-family-outing" },
//   { place: "/images/keyword/20.jpg", text: "Destination wedding place near Bhandara", link: "destination-wedding-place-near-Bhandara" },
//   { place: "/images/keyword/21.jpg", text: "Best picnic spot near Buldhana", link: "best-picnic-spot-near-Buldhana" },
//   { place: "/images/keyword/22.jpg", text: "One day tour near Buldhana", link: "one-day-tour-near-Buldhana" },
//   { place: "/images/keyword/23.jpg", text: "Family resorts near Buldhana", link: "family-resorts-near-Buldhana" },
//   { place: "/images/keyword/24.jpg", text: "Wedding destination near Buldhana", link: "wedding-destination-near-Buldhana" },
//   { place: "/images/keyword/25.jpg", text: "Picnic spot near Chandrapur", link: "picnic-spot-near-Chandrapur" },
];



  const images = [
    { src: "/images/galleryy/3.jpg", alt: "Image 1" },
    { src: "/images/galleryy/2.jpg", alt: "Image 1" },
    { src: "/images/galleryy/3.jpg", alt: "Image 1" },
    { src: "/images/galleryy/4.jpg", alt: "Image 1" },
    { src: "/images/galleryy/5.jpg", alt: "Image 1" },
    { src: "/images/galleryy/6.jpg", alt: "Image 1" },
    { src: "/images/galleryy/7.jpg", alt: "Image 1" },
    { src: "/images/galleryy/8.jpg", alt: "Image 1" },
    { src: "/images/galleryy/9.jpg", alt: "Image 1" },
  ];


const productSchema = {
  "@context": "https://schema.org",
  "@type": "Product",
  "name": "Best Picnic Spot Near Amravati",
  "image": "https://woodlandescape.com/assets/images/best-picnic-spot-near-amravati.jpg",
  "description": "Enjoy a perfect outing at Woodlandescape Resort — the best picnic spot near Amravati. Ideal for families, friends, and nature lovers with scenic views, outdoor activities, and fun-filled weekend trips.",
  "brand": {
    "@type": "Brand",
    "name": "Woodlandescape Resort"
  },
  "aggregateRating": {
    "@type": "AggregateRating",
    "bestRating": "5",
    "worstRating": "1",
    "ratingValue": "4.9",
    "ratingCount": "785"
  },
  "offers": {
    "@type": "Offer",
    "priceCurrency": "INR",
    "price": "1099",
    "availability": "https://schema.org/InStock",
    "url": "https://woodlandescape.com/best-picnic-spot-near-amravati"
  }
};




  return (
    <div>
<Helmet>
  <title>Best Picnic Spot Near Amravati | Scenic & Family Friendly | Woodlandescape Resort</title>
  <meta 
    name="description" 
    content="Plan a delightful picnic at Woodlandescape Resort — the best picnic spot near Amravati. Enjoy outdoor activities, nature views, and a family-friendly environment for weekends and day trips." 
  />
  <meta 
    name="keywords" 
    content="Best Picnic Spot Near Amravati, Amravati Top Picnic Places, Amravati Family Picnic Spot, Amravati Nature Picnic Spot, Affordable Picnic Spot Amravati, Amravati Weekend Picnic, Amravati Riverside Picnic Spot, Amravati Garden Picnic Spot, Amravati Hill Picnic Spot, Amravati Kids Friendly Picnic Spot, Amravati Scenic Picnic Spot, Amravati Outdoor Picnic Spot, Amravati Picnic Spot Booking, Amravati Picnic Tour Packages, Amravati Top Weekend Picnic Spot" 
  />
  <script type="application/ld+json">
    {JSON.stringify(productSchema)}
  </script>
</Helmet>
   <section
  className="page-title"
  style={{
    backgroundImage: `
      linear-gradient(
        rgba(0, 0, 0, 0.6),
        rgba(0, 0, 0, 0.6)
      ),
      url(/images/page-title.jpg)
    `,
    backgroundSize: "cover",
    backgroundPosition: "center",
  }}
>
  <div className="auto-container">
    <div className="text-center">
            <h1>{cardData.keyword}</h1>
    </div>
  </div>
</section>

  


      <section>
        <div className="container-fluid" >
          <div className="row container-fluid">
            <div className="col-12 col-md-8 ">
              <img src='/images/keyword/13.jpg' alt='img' />
              <h3 className="py-1"
                style={{
                  color: '#2AA248', // green color
                  textShadow: '5px 5px 10px rgba(255, 255, 255, 0.7)', // Light shadow effect
                  fontWeight: 'bold'
                }}


              >{cardData.heading} </h3><p className=' leadd'>{cardData.headingDescription}</p>
              <div className="">
                <p className='fw-bold py-3'>{cardData.top}</p>
                {cardData.topPlaces.map((place, index) => (
                  <div key={index} className="">
                    <div
                      style={{
                        cursor: 'pointer',
                        padding: '10px',
                        marginBottom: '7px',
                        borderRadius: '8px', // Optional: rounded corners
                        transition: 'transform 0.2s' // Optional: smooth scaling effect
                      }}
                    // Centers text within the card
                    >
                      <h4 className="mb-1 darkcolor">{place.title}</h4>
                      <p className="mb-0">{place.description}</p>
                    </div>
                  </div>
                ))}
              </div>
              <div
                style={{
                  cursor: 'pointer',
                  padding: '10px',
                  marginBottom: '7px',
                  borderRadius: '8px', // Optional: rounded corners
                  transition: 'transform 0.2s' // Optional: smooth scaling effect
                }}
              >
                {cardData.services.map((service, index) => (
                  <div key={index} className=" my-4">
                    <h4 className="py-1 darkcolor">{service.name}</h4>
                    <p>{service.description}</p>
                  </div>
                ))}
              </div>


              <div id="why-choose-section"
                className='px-2'>
                {cardData.whychoose.map((item, index) => (
                  <div key={index}>
                    <h4 className="py-1 whycolor">{item.WhyChooseheading}</h4>
                    <p>{item.WhyChoosedescription}</p>
                  </div>
                ))}
              </div>


              <div>

              </div>


            </div>

            <div className='col-12 col-md-4' >


              <div className=" rounded p-4 shadow-sm Uni_border"
                style={{
                  cursor: 'pointer',
                  padding: '10px',
                  border: '3px dotted #2AA248',
                  marginBottom: '7px',
                  fontWeight: 'bold',
                }}

              >
                <h4 className="pb-3 pt-3 lead fw-bold text-dark">Contact Information</h4>

                <div className="row">

                  <div className="col-12 mb-3">
                    <div className="Small_border  rounded text-center py-2 " style={{ backgroundColor: '#2AA248' }}>
                      <h4 className=" lead fw-semibold whitt">Phone Numbers</h4>
                      <i className="bi bi-telephone-fill fs-1 mb-2"></i>
                      <div className=''>
                        <a href="tel:+91 9175577266" className="d-block  text-white">+91 9175577266</a>

                      </div>
                    </div>
                  </div>


                  <div className="col-12 mb-3 ">
                    <div className="Small_border rounded text-center">
                      <i className="bi bi-envelope fs-1 mb-2"></i>
                      <div className='rounded py-2' style={{ backgroundColor: '#2AA248' }}>
                        <h4 className=" fw-semibold lead whitt">Email</h4>
                        <a href="mailto:woodlandescape01@gmail.com" className=" text-white d-block">
                          woodlandescape01@gmail.com
                        </a>
                      </div>
                    </div>
                  </div>


                  <div className="col-12 mb-3">
                    <div className="Small_border  rounded text-center">
                      <i className="bi bi-house-fill fs-1 mb-2"></i>
                      <div className='rounded py-2' style={{ backgroundColor: '#2AA248' }}>
                        <h4 className=" fw-semibold lead whitt">Address</h4>
                        <p className="whit text-white ">
                          <i> Woodland Escape Resort:<br />
                            Wadamba, Behind St. Peters School, Deolapar, Dist. Nagpur - <br />441401

                          </i>
                        </p>
                      </div>
                    </div>
                  </div>

                </div>
              </div>


              {/* {Images.map((e) => {
                return (
                  <div className="box1">
                    <a
                      href="./"
                      className="d-flex justify-content-around align-items-center"
                    >
                      <div className="b1">
                        <img src={e.place} alt="img" />
                      </div>
                      <div className="b2">
                        {" "}
                        <a href="./" className='darkcolorr'>{e.text}</a>
                      </div>
                    </a>
                  </div>
                );
              })} */}


              
{Images.map((e, index) => {
  return (
    <div className="box1" key={index}>
      <a
        href={`/${e.link}`}
        className="d-flex justify-content-around align-items-center"
      >
        <div className="b1">
          <img src={e.place} alt={e.text} />
        </div>
        <div className="b2 darkcolorr">
          {e.text}
        </div>
      </a>
    </div>
  );
})}



             <Gallery images={images} ></Gallery>
              <table className="table table-responsive custom-table my-4">
                <thead>
                  <tr>
                    {cardData?.tableHeaders?.map((header, index) => (
                      <th key={index} className="custom-th">{header}</th>
                    ))}
                  </tr>
                </thead>
                <tbody>
                  {cardData?.tableData?.map((row, rowIndex) => (
                    <tr className="custom-row" key={rowIndex}>
                      {row?.map((cell, cellIndex) => (
                        <td key={cellIndex} className="custom-td">
                          {cell}
                        </td>
                      ))}
                    </tr>
                  ))}
                </tbody>
              </table>


              <div>
                <h3 className='Colo'>FAQs {cardData.keyword} for Woodland Escape Resort</h3>
                <Accordion data={faqData} />
              </div>
              <div className='py-3'>
                <CustomCarousel items={carouselItems} options={carouselOptions} />
              </div>


              {/* <div className="contact-box Borderr mt-5">
                <h3>{contactData.heading}</h3>
                <p className='text-black'>For booking inquiries or any assistance, please feel free to contact us:</p>
                <div className="contact-details">
                  <p><strong className='darkcolor'>Mobile No:</strong></p>
                  <ul>
                    {contactData.contactNumbers.map((number, index) => (
                      <li key={index}>
                        <a href={`tel:${number}`} className="contact-link fw-bold fs-5">
                          {number}
                        </a>
                      </li>
                    ))}
                  </ul>

                  <p><strong className='darkcolor'>Email Id: </strong>
                    <a href={`mailto:${contactData.email}`} className="contact-link">
                      {contactData.email}
                    </a>
                  </p>
                </div>
              </div> */}
<div className="contact-box woodland-theme mt-5">
  <h3 className="heading">{contactData.heading}</h3>
  <p className="subtext">
    For booking inquiries or any assistance, please feel free to contact us:
  </p>

  <div className="contact-details">
    <p className="label">📞 Mobile No:</p>
    <ul className="number-list">
      {contactData.contactNumbers.map((number, index) => (
        <li key={index}>
          <a href={`tel:${number}`} className="contact-link">
            {number}
          </a>
        </li>
      ))}
    </ul>

    <p className="label">📧 Email Id:</p>
    <a href={`mailto:${contactData.email}`} className="contact-link email-link">
      {contactData.email}
    </a>
  </div>
</div>



            </div>
            {/* <BusRatesTable /> */}
          </div>
        </div>
      </section>






    </div>
  );
}

export default Bestpicnicspotnearamravati;